import axios from "axios";
import { getToken } from "./storage";

// const API_URL = "https://368394b4-1107-496f-8ef2-0baffc786c47.mock.pstmn.io/";

export const API_URL = process.env.REACT_APP_API_URL;

export const CancelToken = axios.CancelToken;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// API Request Interceptor
api.interceptors.request.use(
  (config) => {
    const token = getToken();

    // Block the api call if 'access-token' is unavailable
    if (!token) {
      const cancelToken = new CancelToken((cancel) => cancel("Rejected"));
      return { ...config, cancelToken };
    }

    config.headers["Authorization"] = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

// Add Response Interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Any status codes outside
    if (error.response && error.response.status === 403) {
      // Handle 401 error (Unauthorized)
      console.log("Unauthorized, logging out...");
      window.location.href = "/logout";
    }
    return Promise.reject(error);
  }
);

export async function apiData(req, contentType = "application/json") {
  const { url, method, data } = req;

  // console.log("token--------", getToken());

  try {
    const res = await axios({
      url: API_URL + url,
      method: method,
      data: data,
      headers: {
        "Content-Type": contentType,
        Authorization: `Bearer ${getToken()}`,
      },
    });

    return res.data;
  } catch (error) {
    if (
      error.message === "Network Error" ||
      (error.response && error.response.status === 401)
    ) {
      window.location.href = "/logout";
    }
    console.log("Failed to fetch data", error);
    return error.response.data;
  }
}

export default api;
